module.exports = __webpack_public_path__ + "img/003.9a31908c.svg";